import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataFilterDisplayService } from '../../interface';

@Injectable({ providedIn: 'root' })
export class IntegerDisplayService implements DataFilterDisplayService {
  getDisplay(value: number): Observable<string> {
    return of(`<b>${value}</b>`);
  }
}
